import React from 'react'
import { connect } from 'react-redux'
import { actions as formActions, getModel } from 'react-redux-form'

import { required } from './validations'
import Field from './Field'
import Form from './Form'

import { getForm, submitHubspotForm } from '../../actions/actions'
import * as v from '../form/validations'
import ActionButton from '../../../js/components/ActionButton'
import { receivedResponse } from '../../../js/h2Api'

class HubSpotForm extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      form: null,
      showConfirmation: false
    }
    this.formModelName = 'forms.genericForm'
  }

  updateForm = () => {
    this.props
      .dispatch(getForm(this.props.formId))
      .then(f => {
        const reqFields = {}

        if (this.props.onFormLoad) {
          this.props.onFormLoad(f)
        }

        f.formFieldGroups.forEach(fg =>
          fg.fields.forEach(fl => {
            reqFields[`${fl.name}`] = fl.defaultValue || ''
          })
        )

        // console.log(reqFields, this.props.formModel);
        this.props.dispatch(formActions.merge(this.formModelName, reqFields))
        this.props.dispatch(formActions.validate(this.formModelName))

        //console.log(reqFields, this.props.formModel);
        return f
      })
      .then(f => {
        console.log(this.props.quoteFormPresetOptions)

        if (
          this.props.quoteFormPresetOptions &&
          Object.keys(this.props.quoteFormPresetOptions).length > 0
        ) {
          this.props.dispatch(
            formActions.merge(this.formModelName, this.props.quoteFormPresetOptions)
          )
        }

        this.setState({ ...this.state, form: f })
      })
  }

  componentDidMount = () => {
    if (!this.state.form) {
      this.updateForm()
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.formId !== prevProps.formId) {
      this.updateForm()
    }
  }

  validationMap = {
    email: [v.email()]
  }
  addValidationAttr = key => {
    if (this.validationMap[key]) {
      return { validation: this.validationMap[key] }
    }

    return {}
  }

  handleFormSubmission = p => {
    console.log(p)
    const newP = {}

    Object.keys(p).forEach(k => {
      const v = p[k]

      if (typeof v === 'object') {
        newP[k] = Object.keys(v).join('; ')
      } else {
        newP[k] = v
      }
    })
    console.log(newP)

    return this.props.dispatch(submitHubspotForm(this.props.formId, newP)).then(v => {
      if (this.props.onSubmit) {
        return this.props.onSubmit(v)
      }

      this.setState({
        ...this.state,
        showConfirmation: true
      })

      if (this.props.executeOnSubmit) {
        this.props.executeOnSubmit(v)
      }
    })
  }

  outputForm = () => {
    if (!this.state.form) {
      return null
    }

    if (this.state.showConfirmation) {
      //if there are children, we'll use that as the confirmation
      if (this.props.children) {
        return this.props.children
      }

      return this.state.form.inlineMessage ? (
        <div
          className="alert alert-success text-center"
          dangerouslySetInnerHTML={{ __html: this.state.form.inlineMessage }}>
        </div>
      ) : (
        <div>
          <div className="alert alert-success text-center">
            <h3>Your inquiry has been submitted</h3>
            <p>
              Thank you for contacting us, we will be in touch shortly regarding your
              request.
            </p>
          </div>
        </div>
      )
    }

    return (
      <div style={{ marginTop: '30px' }}>
        {this.props.showTitle && <h3>{this.state.form.name}</h3>}
        <Form
          model={this.formModelName}
          key="forms.genericForm.key"
          validate={{
            email: [required('email'), v.targetField('email', v.email())]
          }}
          onSubmit={this.handleFormSubmission}>
          {form => {
            const fieldData = this.state.form.formFieldGroups.flatMap(fg =>
              fg.fields.map(fl => {
                if (
                  (fl.fieldType === 'checkbox' || fl.fieldType === 'radio') &&
                  fl.hasOwnProperty('options')
                ) {
                  return (
                    <div className="row">
                      <div className="col-xs-12">
                        <label>
                          {fl.label} {fl.required ? ' *' : ''}
                        </label>
                      </div>
                      {fl.options
                        .sort((a, b) => a.displayOrder - b.displayOrder)
                        .map(op => {
                          return (
                            <div className="col-xs-6">
                              <Field
                                model={`${this.formModelName}.${fl.name}.${op.value}`}
                                form={form}
                                type={fl.fieldType}
                                value={op.value}
                                label={op.label}
                              />
                            </div>
                          )
                        })}
                    </div>
                  )
                }

                if (fl.fieldType === 'select' && fl.hasOwnProperty('options')) {
                  return (
                    <div className="row">
                      <div className="col-xs-12">
                        <Field
                          model={`${this.formModelName}.${fl.name}`}
                          form={form}
                          required={fl.required}
                          type={fl.fieldType}
                          label={fl.label}
                          description={fl.description}
                          {...this.addValidationAttr(fl.name)}>
                          <option value="">{'Please choose one'}</option>
                          {fl.options.map(v => (
                            <option key={v.value} value={v.value}>
                              {v.label}
                            </option>
                          ))}
                        </Field>
                      </div>
                    </div>
                  )
                }

                //  console.log(`${this.formModelName}.${fl.name}`, this.props.formModel[`${this.formModelName}.${fl.name}`], fl.required, fl);
                return (
                  <div className="row">
                    <div className="col-xs-12">
                      <Field
                        model={`${this.formModelName}.${fl.name}`}
                        form={form}
                        required={fl.required}
                        description={fl.description}
                        type={fl.fieldType}
                        placeholder={fl.label}
                        {...this.addValidationAttr(fl.name)}
                      />
                    </div>
                  </div>
                )
              })
            )

            return (
              <div>
                {fieldData}
                <div className="row">
                  <div className="col-xs-6 col-sm-8"></div>
                  <div className="col-xs-6 col-sm-4">
                    <ActionButton
                      className="btn btn-full btn-success btn-lg btn-outline-success"
                      style={{ width: '100%' }}
                      loading={this.props.formRequest.loading}
                      error={this.props.formRequest.error}
                      success={
                        receivedResponse(this.props.formRequest) && `Form Submitted`
                      }>
                      {`Submit`}
                    </ActionButton>
                  </div>
                </div>
              </div>
            )
          }}
        </Form>
      </div>
    )
  }

  render = () => {
    return <div>{this.outputForm()}</div>
  }
}

export default connect(
  state => {
    return {
      formModel: getModel(state, 'forms.genericForm'),
      quoteFormPresetOptions: state.forms.quoteFormPresetReducer,
      formRequest: state.forms.formRequest
    }
  },
  dispatch => {
    return {
      dispatch
    }
  }
)(HubSpotForm)
